import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import LoadingSpinner from "../components/LoadingSpinner";

const VersionForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    iosVersion: "",
    androidVersion: "",
    description: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      if (id) {
        // Update API version
        const res = await axiosInstance.put(`/api-versions/${id}`, formValues);
        if (res) {
          toast.success("API version updated successfully");
          setLoading(false);
          navigate("/apiVersions"); // Redirect after success (adjust the path as needed)
        }
      } else {
        // Create new API version
        const res = await axiosInstance.post("/api-versions/create", formValues);
        if (res) {
          toast.success("API version created successfully");
          setLoading(false);
          navigate("/apiVersions"); // Redirect after success (adjust the path as needed)
        }
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "An error occurred");
    }
  };

  // Fetch API version data for edit
  useEffect(() => {
    if (id) {
      const fetchApiVersion = async () => {
        try {
          setLoading(true);
          const res = await axiosInstance.get(`/api-versions/${id}`);
          if (res.data.data) {
            setFormValues({
              iosVersion: res.data.data.iosVersion,
              androidVersion: res.data.data.androidVersion,
              description: res.data.data.description,
            });
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          toast.error(error?.response?.data?.message || "An error occurred");
        }
      };

      fetchApiVersion();
    }
  }, [id]);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">{id ? "Edit API Version" : "Create API Version"}</h1>
      {loading && <LoadingSpinner />}
      
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded-md shadow-md">
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">iOS Version</label>
          <input
            type="text"
            name="iosVersion"
            value={formValues.iosVersion}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter iOS Version"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Android Version</label>
          <input
            type="text"
            name="androidVersion"
            value={formValues.androidVersion}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter Android Version"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Description</label>
          <textarea
            name="description"
            value={formValues.description}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
            placeholder="Enter Description"
            rows="5"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          {id ? "Update" : "Create"} API Version
        </button>
      </form>
    </div>
  );
};

export default VersionForm;
